import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useAdmin } from '../contexts/AdminContext';
import { Alert, Box, CircularProgress, Typography, Button } from '@mui/material';

const AdminProtectedRoute = ({ children }) => {
  const { currentUser, isAuthenticated } = useAuth();
  const { isAdmin, isLoading } = useAdmin();
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);

  // Utiliser useEffect pour gérer la redirection uniquement au chargement initial
  useEffect(() => {
    // Attendre que le chargement soit terminé
    if (!isLoading) {
      if (!isAuthenticated) {
        // L'utilisateur n'est pas connecté
        setShowError(true);
      } else if (!isAdmin) {
        // L'utilisateur est connecté mais n'est pas administrateur
        setShowError(true);
      }
    }
  }, [isLoading, isAuthenticated, isAdmin]);

  // Si le chargement est en cours, afficher un indicateur de chargement
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>Vérification des permissions...</Typography>
      </Box>
    );
  }

  // Si l'utilisateur est authentifié et est un administrateur, afficher le contenu protégé
  if (isAuthenticated && isAdmin) {
    return children;
  }

  // Afficher un message d'erreur avec un bouton de redirection manuel
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', p: 3 }}>
      <Alert severity="error" sx={{ mb: 2, width: '100%', maxWidth: 500 }}>
        {!isAuthenticated 
          ? "Vous devez être connecté pour accéder à cette page." 
          : "Missing or insufficient permissions. Vous n'avez pas les droits nécessaires pour accéder à cette page."}
      </Alert>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => navigate('/admin-login', { replace: true })}
        sx={{ mt: 2 }}
      >
        Aller à la page de connexion
      </Button>
    </Box>
  );
};

export default AdminProtectedRoute;